import { Component, computed, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { SelectionType } from 'guideline/domain';
import { GuidelineService, SelectionService } from 'shared/domain';

import { GuidelineEditorChapterSidebarWrapperComponent } from './components/chapter-sidebar-wrapper/guideline-editor-chapter-sidebar-wrapper.component';
import { GuidelineEditorComponentListSidebarWrapperComponent } from './components/component-list-sidebar-wrapper/guideline-editor-component-list-sidebar-wrapper.component';
import { GuidelineEditorComponentSidebarWrapperComponent } from './components/component-sidebar-wrapper/guideline-editor-component-sidebar-wrapper.component';
import { GuidelineFlowchartSidebarWrapperComponent } from './components/flowchart-sidebar-wrapper/flowchart-sidebar-wrapper.component';
import { FlowchartWidgetSidebarComponent } from './components/flowchart-widget-sidebar/flowchart-widget-sidebar.component';
import { SidebarHeaderComponent } from './components/sub-components/sidebar-header/sidebar-header.component';
import { WorkflowSidebarWrapperComponent } from './components/workflow-sidebar-wrapper/workflow-sidebar-wrapper.component';
import { SidebarPlaceholderComponent } from '../../../../shared/ui-common/src/lib/components/sidebar-placeholder/sidebar-placeholder.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    GuidelineFlowchartSidebarWrapperComponent,
    GuidelineEditorChapterSidebarWrapperComponent,
    SidebarHeaderComponent,
    GuidelineEditorComponentSidebarWrapperComponent,
    GuidelineEditorComponentListSidebarWrapperComponent,
    WorkflowSidebarWrapperComponent,
    SidebarPlaceholderComponent,
    FlowchartWidgetSidebarComponent,
  ],
  selector: 'guideline-sidebar',
  styleUrls: ['./guideline-sidebar.component.scss'],
  templateUrl: './guideline-sidebar.component.html',
})
export class SidebarComponent {
  private selectionService = inject(SelectionService);
  private guidelineService = inject(GuidelineService);

  @Input() public taxonomyId: string;

  protected currentSidebarType = computed(() => this.selectionService.selection()?.type);
  protected selectedElement = computed(() => this.selectionService.selection());
  protected flowchartId = computed(() => this.selectionService.selection()?.flowchartId);

  protected selectedWidget = computed(() => {
    const selection = this.selectionService.selection();
    if (!selection || selection.type !== SelectionType.Widget) {
      return undefined;
    }

    return this.guidelineService.selectElement(selection.widgetId)();
  });

  protected SelectionTypes = SelectionType;
}
